import type { RecordLikeProtocol, ViewCustomStatisticValues } from '@lighthouse/core'
import React from 'react'

export interface CustomViewBlockContextValue {
    /** 区分管理端/应用端 */
    readonly?: boolean
    /** 区分可编辑的第一条记录 */
    editable: boolean
    name: string
    viewId: string
    pointer: string
    record: RecordLikeProtocol | undefined
    /** 外层自定义视图。嵌套时视图控制器看到的 record 在这里。 */
    parentCustomView?: CustomViewBlockContextValue
    /** 记录索引路径（字符串，便于拼接），用于自定义视图下 block 的 anchor id 后缀，如 "0"、"0_1"、"1_2" */
    recordIndexPath?: string
    /** 只有记录自身的点击动作会阻止外层视图点击；隐藏浮层不参与这个判断。 */
    hasRecordAction?: boolean
    handleRecordClick: (e: React.MouseEvent) => void
}

const CustomViewBlockContext = React.createContext<CustomViewBlockContextValue>({
    editable: false,
    name: '',
    viewId: '',
    pointer: '',
    record: undefined,
    recordIndexPath: undefined,
    hasRecordAction: false,
    handleRecordClick: () => void 0
})
export const CustomViewBlockProvider = CustomViewBlockContext.Provider
export const useCustomViewBlockContext = () => React.useContext(CustomViewBlockContext)

const CustomViewStatisticContext = React.createContext<ViewCustomStatisticValues | undefined>(undefined)
export const CustomViewStatisticProvider = CustomViewStatisticContext.Provider
export const useCustomViewStatisticValues = () => React.useContext(CustomViewStatisticContext)
